import { Box, Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import heroM6Dm from './images/bydm6dm/m6dmextfront-3.webp';
import sideM6Dm from './images/bydm6dm/m6dmextside-2.webp';
import rearM6Dm from './images/bydm6dm/m6dmextback-1.webp';
import menuM6Dm from './images/bydm6dm/menu-1.webp';
import prebookM6Dm from './images/bydm6dm/WhatsApp Image 2026-05-18 at 8.49.24 AM.jpeg';
import technologyM6Dm from './images/bydm6dm/WhatsApp Image 2026-05-18 at 8.49.42 AM.jpeg';
import showroomM6Dm from './images/bydm6dm/WhatsApp Image 2026-05-18 at 9.01.02 AM.jpeg';
import interiorDashM6Dm from './images/bydm6dm/WhatsApp Image 2026-05-18 at 9.18.33 AM (1).jpeg';
import interiorClusterM6Dm from './images/bydm6dm/WhatsApp Image 2026-05-18 at 9.18.34 AM.jpeg';
import interiorCabinM6Dm from './images/bydm6dm/WhatsApp Image 2026-05-18 at 9.18.34 AM (1).jpeg';
import interiorSeatM6Dm from './images/bydm6dm/WhatsApp Image 2026-05-18 at 9.18.34 AM (2).jpeg';
import interiorPanoramicM6Dm from './images/bydm6dm/WhatsApp Image 2026-05-18 at 9.18.33 AM.jpeg';
import interiorRoofM6Dm from './images/bydm6dm/WhatsApp Image 2026-05-18 at 9.18.33 AM (2).jpeg';
import PageSeo, {
  absoluteUrl,
  breadcrumbJsonLd,
  keywordSets,
  localBusinessJsonLd,
} from './PageSeo';

const waLink =
  'https://api.whatsapp.com/send?phone=6281286864825&text=Halo%20saya%20ingin%20info%20BYD%20M6%20DM%2C%20harga%20coming%20soon%2C%20dan%20jadwal%20test%20drive%20di%20BYD%20BSD%20Serpong';

const specs = [
  { value: '10.1s', label: '0 - 100 km/h' },
  { value: '18 kWh', label: 'Battery capacity' },
  { value: '52 L', label: 'Fuel capacity' },
  { value: '1200 km', label: 'Range NEDC' },
];

const highlights = [
  {
    title: 'Mobil listrik yang bisa diisi bensin',
    text: 'BYD M6 DM memakai pendekatan plug-in hybrid berbasis listrik. Untuk rute harian, mobil bisa terasa seperti EV; untuk perjalanan jauh, mesin bensin membantu menjaga jarak tempuh tetap panjang.',
  },
  {
    title: 'Fleksibel untuk keluarga',
    text: 'Format MPV membuat M6 DM relevan untuk keluarga yang butuh kabin lapang, biaya harian efisien, dan tetap tenang saat harus keluar kota.',
  },
  {
    title: 'Teknologi DM dari BYD',
    text: 'DM atau Dual Mode menggabungkan motor listrik, baterai, dan mesin bensin agar mobil bisa menyesuaikan sumber tenaga sesuai kondisi jalan dan kebutuhan perjalanan.',
  },
];

const gallery = [
  {
    image: heroM6Dm,
    title: 'Tampilan depan BYD M6 DM',
    text: 'Desain MPV modern dengan karakter keluarga yang tetap bersih dan futuristik.',
  },
  {
    image: sideM6Dm,
    title: 'Profil samping MPV keluarga',
    text: 'Proporsi panjang dan kabin lega dibuat untuk perjalanan harian maupun antar kota.',
  },
  {
    image: rearM6Dm,
    title: 'Bagian belakang BYD M6 DM',
    text: 'Area belakang dibuat praktis untuk kebutuhan keluarga dan barang bawaan.',
  },
  {
    image: prebookM6Dm,
    title: 'Pre-book BYD M6 DM',
    text: 'Materi pre-book menegaskan positioning M6 DM: gesit, andal, senyap, dan super irit.',
  },
  {
    image: technologyM6Dm,
    title: 'Dual Mode Technology',
    text: 'Teknologi DM menggabungkan karakter EV dengan efisiensi bensin untuk rute harian dan perjalanan jauh.',
  },
  {
    image: showroomM6Dm,
    title: 'Unit BYD M6 DM di showroom',
    text: 'Calon pembeli bisa konsultasi ketersediaan unit, harga coming soon, dan jadwal test drive.',
  },
];

const interiorGallery = [
  {
    image: interiorDashM6Dm,
    title: 'Speedometer digital',
    text: 'Panel speedometer digital menampilkan informasi berkendara seperti status HEV, konsumsi energi, tekanan ban, dan data perjalanan.',
  },
  {
    image: interiorClusterM6Dm,
    title: 'Kursi penumpang',
    text: 'Kursi penumpang terlihat lega dengan armrest dan posisi duduk yang nyaman untuk perjalanan harian maupun keluarga.',
  },
  {
    image: interiorCabinM6Dm,
    title: 'Kursi depan, tengah, dan row 3',
    text: 'Foto ini memperlihatkan susunan kabin dari kursi depan, baris tengah, sampai row 3 agar calon pembeli lebih mudah membayangkan ruang penumpang.',
  },
  {
    image: interiorSeatM6Dm,
    title: 'Kursi depan',
    text: 'Tampilan kursi depan memperlihatkan posisi duduk pengemudi dan penumpang depan dengan konsol tengah yang praktis.',
  },
  {
    image: interiorPanoramicM6Dm,
    title: 'Dashboard dan setir',
    text: 'Bagian dashboard dan setir memperlihatkan layout layar tengah, panel instrumen, serta kontrol yang mudah dijangkau pengemudi.',
  },
  {
    image: interiorRoofM6Dm,
    title: 'Fokus setir',
    text: 'Foto ini menonjolkan setir multifungsi BYD M6 DM dengan tombol kontrol yang membantu pengemudi mengakses fitur utama.',
  },
];

const faqItems = [
  {
    question: 'Apa itu BYD M6 DM?',
    answer:
      'BYD M6 DM adalah MPV plug-in hybrid dengan teknologi Dual Mode. Mobil ini menggabungkan karakter berkendara listrik dengan fleksibilitas mesin bensin untuk jarak tempuh lebih panjang.',
  },
  {
    question: 'Apakah BYD M6 DM bisa diisi bensin?',
    answer:
      'Bisa. BYD M6 DM menggunakan sistem plug-in hybrid, jadi pengguna bisa memanfaatkan tenaga listrik dan tetap memiliki tangki bensin untuk perjalanan jauh.',
  },
  {
    question: 'Berapa jarak tempuh BYD M6 DM?',
    answer:
      'Data awal yang ditampilkan di halaman ini adalah range hingga 1200 km NEDC, dengan kapasitas baterai 18 kWh dan tangki bahan bakar 52 liter.',
  },
  {
    question: 'Berapa harga BYD M6 DM?',
    answer:
      'Harga BYD M6 DM masih coming soon. Hubungi Junius di BYD BSD Serpong untuk update harga, ketersediaan unit, dan jadwal test drive.',
  },
];

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

const productJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'BYD M6 DM',
  url: absoluteUrl('/jelajahi-m6-dm'),
  image: [
    absoluteUrl(heroM6Dm),
    absoluteUrl(sideM6Dm),
    absoluteUrl(rearM6Dm),
    absoluteUrl(prebookM6Dm),
    absoluteUrl(technologyM6Dm),
    absoluteUrl(showroomM6Dm),
    absoluteUrl(interiorDashM6Dm),
    absoluteUrl(interiorSeatM6Dm),
    absoluteUrl(interiorRoofM6Dm),
  ],
  description:
    'BYD M6 DM adalah MPV plug-in hybrid dengan teknologi Dual Mode, range hingga 1200 km NEDC, akselerasi 0-100 km/h 10.1 detik, baterai 18 kWh, dan tangki bahan bakar 52 liter.',
  about: {
    '@type': 'Vehicle',
    name: 'BYD M6 DM',
    brand: {
      '@type': 'Brand',
      name: 'BYD',
    },
    additionalProperty: [
      { '@type': 'PropertyValue', name: '0-100 km/h', value: '10.1 detik' },
      { '@type': 'PropertyValue', name: 'Battery capacity', value: '18 kWh' },
      { '@type': 'PropertyValue', name: 'Fuel capacity', value: '52 liter' },
      { '@type': 'PropertyValue', name: 'Range NEDC', value: '1200 km' },
    ],
  },
};

function JelajahiM6DM() {
  return (
    <>
      <PageSeo
        title='BYD M6 DM Indonesia | MPV Plug-in Hybrid 1200 KM NEDC'
        description='Jelajahi BYD M6 DM di BYD BSD Serpong: MPV plug-in hybrid Dual Mode, 10.1s 0-100 km/h, baterai 18 kWh, tangki 52 liter, dan range 1200 km NEDC.'
        keywords={[
          ...keywordSets.localDealer,
          'BYD M6 DM',
          'BYD M6 DM Indonesia',
          'harga BYD M6 DM',
          'BYD M6 DM BSD Serpong',
          'mobil listrik bisa bensin',
          'MPV plug-in hybrid BYD',
          'BYD M6 hybrid',
          'BYD M6 PHEV',
        ]}
        path='/jelajahi-m6-dm'
        image={menuM6Dm}
        jsonLd={[
          localBusinessJsonLd(),
          productJsonLd,
          breadcrumbJsonLd([
            { name: 'Beranda', path: '/' },
            { name: 'BYD M6 DM', path: '/jelajahi-m6-dm' },
          ]),
          faqJsonLd,
        ]}
      />

      <Box component='main' sx={{ width: '100%', overflow: 'hidden' }}>
        <HeroSection />
        <IntroSection />
        <SpecSection />
        <GallerySection />
        <InteriorSection />
        <FaqSection />
        <CtaSection />
      </Box>
    </>
  );
}

function HeroSection() {
  return (
    <Box
      component='section'
      aria-labelledby='m6dm-hero-title'
      sx={{
        position: 'relative',
        minHeight: { xs: '92vh', md: '100vh' },
        pt: { xs: 9, md: 10 },
        display: 'flex',
        alignItems: 'flex-end',
        overflow: 'hidden',
        backgroundColor: '#111827',
      }}
    >
      <Box
        component='img'
        src={heroM6Dm}
        alt='BYD M6 DM plug-in hybrid'
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(180deg, rgba(0,0,0,0.24) 0%, rgba(0,0,0,0.12) 38%, rgba(0,0,0,0.82) 100%)',
        }}
      />

      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          width: '100%',
          maxWidth: 1180,
          mx: 'auto',
          px: { xs: 2, md: 5 },
          pb: { xs: 5, md: 7 },
          color: '#fff',
        }}
      >
        <Typography
          sx={{
            display: 'inline-flex',
            px: 1.2,
            py: 0.65,
            borderRadius: '999px',
            backgroundColor: 'rgba(255,255,255,0.12)',
            border: '1px solid rgba(255,255,255,0.2)',
            fontSize: '0.78rem',
            fontWeight: 900,
            letterSpacing: 0.4,
            textTransform: 'uppercase',
          }}
        >
          BYD M6 DM
        </Typography>
        <Typography
          id='m6dm-hero-title'
          component='h1'
          sx={{
            mt: 1.6,
            fontSize: { xs: '2.35rem', sm: '3.5rem', md: '5rem' },
            fontWeight: 900,
            lineHeight: 0.98,
            maxWidth: 820,
          }}
        >
          MPV listrik yang bisa diisi bensin
        </Typography>
        <Typography
          sx={{
            mt: 1.5,
            maxWidth: 760,
            fontSize: { xs: '1rem', md: '1.12rem' },
            lineHeight: 1.75,
            color: 'rgba(255,255,255,0.92)',
          }}
        >
          BYD M6 DM membawa teknologi Dual Mode untuk keluarga yang ingin rasa
          berkendara listrik, tetapi tetap punya fleksibilitas bensin untuk
          perjalanan jauh.
        </Typography>

        <Box
          sx={{
            mt: { xs: 3, md: 4 },
            display: 'grid',
            gridTemplateColumns: { xs: '1fr 1fr', sm: 'repeat(4, 1fr)' },
            gap: 1,
            maxWidth: 880,
          }}
        >
          {specs.map((spec) => (
            <Box
              key={spec.label}
              sx={{
                border: '1px solid rgba(255,255,255,0.24)',
                backgroundColor: 'rgba(0,0,0,0.36)',
                px: 1.8,
                py: 1.4,
                borderRadius: '8px',
              }}
            >
              <Typography sx={{ fontSize: '1.18rem', fontWeight: 900 }}>
                {spec.value}
              </Typography>
              <Typography sx={{ fontSize: '0.82rem', opacity: 0.82 }}>
                {spec.label}
              </Typography>
            </Box>
          ))}
        </Box>

        <Box sx={{ mt: 3, display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
          <Button
            href={waLink}
            target='_blank'
            rel='noopener noreferrer'
            variant='contained'
            sx={buttonPrimary}
          >
            Tanya M6 DM via WhatsApp
          </Button>
          <Button
            component={RouterLink}
            to='/blog/byd-m6-dm-indonesia'
            variant='outlined'
            sx={buttonGhost}
          >
            Baca artikel M6 DM
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

function IntroSection() {
  return (
    <Box
      component='section'
      aria-labelledby='m6dm-intro-title'
      sx={{ px: { xs: 2, md: 6 }, py: { xs: 7, md: 9 }, backgroundColor: '#fff' }}
    >
      <Box
        sx={{
          maxWidth: 1180,
          mx: 'auto',
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', lg: '0.9fr 1.1fr' },
          gap: { xs: 3, md: 5 },
          alignItems: 'center',
        }}
      >
        <Box>
          <Typography sx={eyebrow}>Teknologi DM BYD</Typography>
          <Typography id='m6dm-intro-title' component='h2' sx={sectionTitle}>
            Cara kerja M6 DM dibuat untuk rutinitas Indonesia
          </Typography>
        </Box>
        <Typography sx={bodyText}>
          Untuk perjalanan pendek, BYD M6 DM bisa memprioritaskan tenaga
          listrik agar kabin terasa halus dan senyap. Saat rute makin panjang,
          sistem Dual Mode mengatur kerja mesin bensin dan motor listrik supaya
          perjalanan tetap efisien tanpa rasa khawatir soal jarak tempuh.
        </Typography>
      </Box>

      <Box
        sx={{
          maxWidth: 1180,
          mx: 'auto',
          mt: 3,
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
          gap: 2,
        }}
      >
        {highlights.map((item) => (
          <Box key={item.title} sx={infoCard}>
            <Typography sx={{ fontSize: '1.2rem', fontWeight: 900 }}>
              {item.title}
            </Typography>
            <Typography sx={{ mt: 1, color: '#4b5563', lineHeight: 1.7 }}>
              {item.text}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

function SpecSection() {
  return (
    <Box
      component='section'
      aria-labelledby='m6dm-spec-title'
      sx={{
        px: { xs: 2, md: 6 },
        py: { xs: 7, md: 9 },
        backgroundColor: '#f4f7fb',
      }}
    >
      <Box sx={{ maxWidth: 1180, mx: 'auto' }}>
        <Typography sx={eyebrow}>Spesifikasi Utama</Typography>
        <Typography id='m6dm-spec-title' component='h2' sx={sectionTitle}>
          Angka yang paling penting untuk pembeli BYD M6 DM
        </Typography>
        <Typography sx={{ ...bodyText, mt: 1.5, maxWidth: 840 }}>
          Kombinasi baterai 18 kWh, tangki 52 liter, dan range 1200 km NEDC
          membuat M6 DM menarik untuk keluarga yang ingin mobil harian hemat
          tetapi tetap fleksibel untuk perjalanan keluar kota.
        </Typography>

        <Box
          sx={{
            mt: 3,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' },
            gap: 2,
          }}
        >
          {specs.map((item) => (
            <Box key={item.label} sx={infoCard}>
              <Typography sx={{ fontSize: '2rem', fontWeight: 900, color: '#111827' }}>
                {item.value}
              </Typography>
              <Typography sx={{ mt: 0.5, color: '#4b5563', fontWeight: 800 }}>
                {item.label}
              </Typography>
            </Box>
          ))}
        </Box>

        <Typography sx={{ mt: 2, color: '#6b7280', fontSize: '0.92rem' }}>
          Harga BYD M6 DM masih coming soon. Spesifikasi dan ketersediaan dapat
          berubah mengikuti informasi resmi dan stok dealer.
        </Typography>
      </Box>
    </Box>
  );
}

function GallerySection() {
  return (
    <Box component='section' sx={{ px: { xs: 2, md: 6 }, py: { xs: 7, md: 9 } }}>
      <Box sx={{ maxWidth: 1180, mx: 'auto' }}>
        <Typography sx={eyebrow}>Galeri BYD M6 DM</Typography>
        <Typography component='h2' sx={sectionTitle}>
          Tampilan M6 DM dari eksterior, teknologi, dan showroom
        </Typography>

        <Box
          sx={{
            mt: 3,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
            gap: 2,
          }}
        >
          {gallery.map((item) => (
            <Box
              key={item.title}
              sx={{
                borderRadius: '8px',
                overflow: 'hidden',
                border: '1px solid rgba(17,24,39,0.08)',
                boxShadow: '0 12px 26px rgba(16,24,40,0.08)',
                backgroundColor: '#fff',
              }}
            >
              <Box
                component='img'
                src={item.image}
                alt={item.title}
                sx={{
                  width: '100%',
                  height: { xs: 220, md: 250 },
                  objectFit: 'cover',
                  display: 'block',
                }}
              />
              <Box sx={{ p: 2.2 }}>
                <Typography sx={{ fontWeight: 900, fontSize: '1.1rem' }}>
                  {item.title}
                </Typography>
                <Typography sx={{ mt: 0.8, color: '#4b5563', lineHeight: 1.65 }}>
                  {item.text}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

function InteriorSection() {
  return (
    <Box
      component='section'
      aria-labelledby='m6dm-interior-title'
      sx={{
        px: { xs: 2, md: 6 },
        py: { xs: 7, md: 9 },
        backgroundColor: '#f4f7fb',
      }}
    >
      <Box sx={{ maxWidth: 1180, mx: 'auto' }}>
        <Typography sx={eyebrow}>Interior BYD M6 DM</Typography>
        <Typography id='m6dm-interior-title' component='h2' sx={sectionTitle}>
          Contoh interior M6 DM untuk gambaran kabin keluarga
        </Typography>
        <Typography sx={{ ...bodyText, mt: 1.5, maxWidth: 840 }}>
          Foto interior ini membantu calon pembeli melihat speedometer digital,
          kursi penumpang, susunan tiga baris kursi, dashboard, dan setir
          sebelum mengatur jadwal lihat unit atau test drive.
        </Typography>

        <Box
          sx={{
            mt: 3,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: 'repeat(3, 1fr)' },
            gap: 2,
          }}
        >
          {interiorGallery.map((item) => (
            <Box
              key={item.title}
              sx={{
                borderRadius: '8px',
                overflow: 'hidden',
                backgroundColor: '#fff',
                border: '1px solid rgba(17,24,39,0.08)',
                boxShadow: '0 12px 26px rgba(16,24,40,0.08)',
              }}
            >
              <Box
                component='img'
                src={item.image}
                alt={item.title}
                loading='lazy'
                sx={{
                  width: '100%',
                  height: { xs: 230, md: 260 },
                  objectFit: 'cover',
                  display: 'block',
                }}
              />
              <Box sx={{ p: 2.2 }}>
                <Typography sx={{ fontWeight: 900, fontSize: '1.1rem' }}>
                  {item.title}
                </Typography>
                <Typography sx={{ mt: 0.8, color: '#4b5563', lineHeight: 1.65 }}>
                  {item.text}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

function FaqSection() {
  return (
    <Box
      component='section'
      aria-labelledby='m6dm-faq-title'
      sx={{ px: { xs: 2, md: 6 }, py: { xs: 7, md: 9 }, backgroundColor: '#f4f7fb' }}
    >
      <Box sx={{ maxWidth: 920, mx: 'auto' }}>
        <Typography id='m6dm-faq-title' component='h2' sx={sectionTitle}>
          FAQ BYD M6 DM
        </Typography>
        <Box sx={{ mt: 2.5, display: 'grid', gap: 1.3 }}>
          {faqItems.map((item) => (
            <Box
              key={item.question}
              component='details'
              sx={{
                p: 2,
                borderRadius: '8px',
                backgroundColor: '#fff',
                border: '1px solid rgba(17,24,39,0.08)',
                '& summary': {
                  cursor: 'pointer',
                  fontWeight: 900,
                  color: '#111827',
                },
              }}
            >
              <Box component='summary'>{item.question}</Box>
              <Typography sx={{ mt: 1.2, color: '#4b5563', lineHeight: 1.75 }}>
                {item.answer}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

function CtaSection() {
  return (
    <Box component='section' sx={{ px: { xs: 2, md: 6 }, py: { xs: 7, md: 9 } }}>
      <Box
        sx={{
          maxWidth: 1080,
          mx: 'auto',
          borderRadius: '8px',
          backgroundColor: '#111827',
          color: '#fff',
          px: { xs: 2.5, md: 4 },
          py: { xs: 3.5, md: 4.5 },
          textAlign: 'center',
        }}
      >
        <Typography component='h2' sx={sectionTitleDark}>
          Mau update harga BYD M6 DM?
        </Typography>
        <Typography
          sx={{
            mt: 1.5,
            maxWidth: 760,
            mx: 'auto',
            color: 'rgba(255,255,255,0.78)',
            lineHeight: 1.8,
          }}
        >
          Hubungi Junius di BYD BSD Serpong untuk info harga coming soon,
          ketersediaan unit, promo, dan jadwal test drive BYD M6 DM.
        </Typography>
        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1.5, flexWrap: 'wrap' }}>
          <Button href={waLink} target='_blank' rel='noopener noreferrer' variant='contained' sx={buttonPrimary}>
            Chat WhatsApp Junius
          </Button>
          <Button component={RouterLink} to='/pricing' variant='outlined' sx={buttonGhost}>
            Lihat daftar harga BYD
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

const eyebrow = {
  color: '#4c5867',
  fontWeight: 800,
  letterSpacing: 0.4,
  textTransform: 'uppercase',
  fontSize: '0.82rem',
};

const sectionTitle = {
  mt: 1,
  fontSize: { xs: '2rem', md: '3rem' },
  fontWeight: 900,
  color: '#111827',
  lineHeight: 1.05,
};

const sectionTitleDark = {
  fontSize: { xs: '2rem', md: '3rem' },
  fontWeight: 900,
  lineHeight: 1.05,
};

const bodyText = {
  color: '#4b5563',
  lineHeight: 1.8,
  fontSize: { xs: '1rem', md: '1.05rem' },
};

const infoCard = {
  p: 2.4,
  borderRadius: '8px',
  backgroundColor: '#fff',
  border: '1px solid rgba(17,24,39,0.08)',
  boxShadow: '0 12px 26px rgba(16,24,40,0.06)',
};

const buttonPrimary = {
  px: 3.2,
  py: 1.1,
  borderRadius: '999px',
  textTransform: 'none',
  fontWeight: 900,
  backgroundColor: '#1f5fd1',
  '&:hover': { backgroundColor: '#184ca8' },
};

const buttonGhost = {
  px: 3.2,
  py: 1.1,
  borderRadius: '999px',
  textTransform: 'none',
  fontWeight: 900,
  color: '#fff',
  borderColor: 'rgba(255,255,255,0.68)',
  '&:hover': {
    borderColor: '#fff',
    backgroundColor: 'rgba(255,255,255,0.1)',
  },
};

export default JelajahiM6DM;
